$(function(){
    function dropdownSkin(){ 
      $('.quantity').append('<div class="clone"><input value="1" type="text" /><ul id="menucontainer"></ul><div class="btn"></div></div>');
      var $menu = $('#menucontainer'); 
      for (i=1;i<11;i++){
      	$menu.append("<li>"+i+"</li>")
      };
      $(document).click(function() {
        $menu.removeClass('active');
      });
      $menu.parent('.clone').children('input').click(function(event) {
        $menu.addClass('active');
        event.stopPropagation();
      });
      $menu.parent('.clone').children('.btn').click(function(event) {
        $menu.toggleClass('active');
        event.stopPropagation();
      });
      $(".quantity .clone li").first().addClass('active');
      $(".quantity .clone li").click(function(){
      	var newVal = $(this).html();
        $(this).addClass('active').siblings().removeClass('active');
      	$(this).parents('.clone').children('input[type="text"]').val(newVal);
        $("#quantity").val(newVal);
      });
    };
    dropdownSkin();
});